var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/* eslint-disable jsdoc/require-returns */
import { Component, html, Prop } from '@sick-davinci/ce-decorators';
import { style } from './Donut.style';
import { ThemeService } from '../_utils/ThemeService.js';
import { AbstractDonut } from './AbstractDonut.js';
import { CssTools } from '../_utils/CssTools.js';
import { SvgTools } from '../_utils/SvgTools.js';
/**
 * Displays arc-elements of defined sizes and colors along a circle.
 *
 * @example
 * ```html
 * <davinci-element-container style="width: 300px; height: 300px">
 *   <davinci-donut values="[20, 5, 12, 1, 10, 55, 60]" legend-labels="['one', 'two', 'three', 'four', 'five', 'six', 'seven']"></davinci-donut>
 * </davinci-element-container>
 * ```
 */

export let Donut = (_dec = Component({
  tag: 'davinci-donut',
  style
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", Object), _dec5 = Prop(), _dec6 = Reflect.metadata("design:type", Number), _dec(_class = _dec2(_class = (_class2 = class Donut extends AbstractDonut {
  /**
   * List of all segment-labels displayed next to the value
   */
  get segmentLabels() {
    return this._segmentLabels;
  }

  set segmentLabels(labels) {
    this._segmentLabels = labels;
  }
  /**
   * Use values < 1 to reduce the scale. Set if space is needed for displaying label-text.
   * If not scale is 0, it is auto determined. This behavior might not be desired, since it can change by each new set label.
   */


  get scale() {
    return this._scale;
  }

  set scale(s) {
    if (s >= 0 && s <= 1) {
      this._scale = s;
    }
  }

  constructor() {
    super(true);
    this._scale = 0;

    this._computeSegmentColors();
  }

  componentConnected() {
    super.componentConnected();
    ThemeService.GET_INSTANCE().addListener(() => this.paletteWatcher());
  }
  /**
   * See base class
   */


  render() {
    var _this$legendLabels;

    if (((_this$legendLabels = this.legendLabels) === null || _this$legendLabels === void 0 ? void 0 : _this$legendLabels.length) > 0) {
      return html`
      <davinci-legend placement="N" compact small-font symbol-size="${CssTools.REM2PIXEL(.7)}" symbols='["box"]'
        .labels=${this.legendLabels} .palette=${this.palette} .colors=${this.colors}>
        ${this._createSVG()}
      </davinci-legend>`;
    } else {
      return this._createSVG();
    }
  }

  componentDidRender() {
    this._scaleSVG();
  }

  _scaleSVG() {
    // scale the svg so it fits either a given scale or the entire-space (auto)
    const svg = this.shadowRoot.querySelector('svg');

    if (this._scale === 0) {
      // auto-scale
      const w = svg.viewBox.baseVal.width;
      const h = svg.viewBox.baseVal.height;
      const bb = SvgTools.SVG_BOX(svg, style); // this._showBBox(bb);

      if (bb.width > w || bb.height > h) {
        // consider width
        const w1 = w / 2 - bb.x; // left edge <-> center

        const w2 = bb.width - w1; // right edge <-> center

        const xScale = w / 2 / Math.max(w1, w2); // consider height

        const h1 = h / 2 - bb.y; // top edge <-> center

        const h2 = bb.height - h1; // bottom edge <-> center

        const yScale = h / 2 / Math.max(h1, h2);
        svg.firstElementChild.setAttribute('transform', `scale(${Math.min(xScale, yScale)})`);
      }
    } else {
      // fixed scale
      svg.firstElementChild.setAttribute('transform', `scale(${this._scale})`);
    }
  }
  /**
   * Show bounding box for debugging purposes
   */


  _showBBox(bb) {
    const r = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    r.setAttribute('x', bb.x.toString());
    r.setAttribute('y', bb.y.toString());
    r.setAttribute('width', bb.width.toString());
    r.setAttribute('height', bb.height.toString());
    r.setAttribute('stroke', 'red');
    r.setAttribute('fill', 'none');
    this.shadowRoot.querySelector('svg').firstElementChild.appendChild(r);
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "segmentLabels", [_dec3, _dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "segmentLabels"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "scale", [_dec5, _dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "scale"), _class2.prototype)), _class2)) || _class) || _class);
